import Vue from 'vue';
import setupVueInstance from './vue-setup';

setupVueInstance(Vue);

export default Vue;
